import {Dispatch, SetStateAction} from 'react'

import {SESSION_STORAGE} from 'app/shared/Common/Constants'

export type ID = undefined | null | number

export type PaginationState = {
  page: number
  items_per_page: number
  options_per_page: number[]
  from?: number
  to?: number
  last_page?: number
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  first_page_url?: string
  next_page_url?: string
  prev_page_url?: string
  total?: number
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: unknown
}

export type SearchState = {
  search?: string
}

export type Response<T> = {
  data?: T
  payload?: {
    message?: string
    errors?: {
      [key: string]: Array<string>
    }
    pagination?: PaginationState
  }
}

export type QueryState = PaginationState & SortState & FilterState & SearchState

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  page: 1,
  items_per_page: Number(sessionStorage.getItem(SESSION_STORAGE.TABLE.PAGINATION.SELECTED_OPTION_PER_PAGE)) || 10,
  options_per_page: [10, 20, 50],
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ConfigProps = {
  actionable: boolean
  expandable: boolean
  filterable: boolean
  groupable: boolean
  searchable: boolean
  toolbarable: boolean
  variant: string
  misc?: {[key: string]: any}
}

export type ListViewContextProps = {
  selected: Array<ID>
  isAllSelected: boolean
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void

  selectedForExpand: Array<ID>
  onSelectForExpand: (selectedId: ID) => void

  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>

  itemIdForDelete?: ID
  setItemIdForDelete: Dispatch<SetStateAction<ID>>

  disabled: boolean

  config: ConfigProps
  onSetConfig: (config: ConfigProps) => void
}

export const initialListView: ListViewContextProps = {
  selected: [],
  isAllSelected: false,
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},

  selectedForExpand: [],
  onSelectForExpand: () => {},

  setItemIdForUpdate: () => {},
  setItemIdForDelete: () => {},

  disabled: false,

  config: {
    actionable: true,
    expandable: true,
    filterable: true,
    groupable: true,
    searchable: true,
    toolbarable: true,
    variant: 'primary',
    misc: {},
  },
  onSetConfig: () => {},
}
